import React, { useState, useEffect } from 'react';
import { useObserver } from 'mobx-react-lite';
import { inject } from 'mobx-react';

import ArtistsListSection from '../artists-list-section.js/artists-list-section';

const injectStores = inject('playlistStore');
const FeaturedArtists = injectStores(({playlistStore}) => {
	const [frontPageLists, setFrontPageLists] = useState(null);

	useEffect(() => {
		const fetchLists = async () => {
			const lists = await playlistStore.fetchMemberHomeLists();
			setFrontPageLists(lists);
		};
		fetchLists();
	}, [playlistStore]);

	return useObserver(() => {
		if (!frontPageLists) {

			return <div>Loading...</div>;
		}

		return (
		    <>
				{ frontPageLists.map(({ title, items }, idx) => (
					<ArtistsListSection
						sectionLabel={title}
						artists={items}
						key={`plyst-${idx}`}
					/>
				))}
		    </>
		);
	});
});

export default FeaturedArtists;
